A document supporting a position-specific selection criteria.
